<template>
  <transition
    enter-active-class="ease-out duration-300"
    enter-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
    enter-to-class="opacity-100 translate-y-0 sm:scale-100"
    leave-active-class="ease-in duration-200"
    leave-class="opacity-100 translate-y-0 sm:scale-100"
    leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
  >
    <ontick-modal
      :showCloseButton="false"
      :open="active"
      size="medium"
      v-on:close="$emit('close')"
      class="text-ontick-steel-900"
    >
      <h2 class="text-ontick-steel-900 text-2xl font-bold dark:text-gray-300">
        Cadastro da conta XP
      </h2>
      <p class="text-sm text-gray-500 dark:text-gray-400">
        Para cadastrar sua conta é muito simples, você só precisa autorizar a
        OnTick diretamente no seu painel de investidor da XP.
        <br />
        <br />
        Veja o passo a passo:
      </p>
      <div class="py-6">
        <div style="padding: 56.25% 0 0 0; position: relative">
          <iframe
            src="https://player.vimeo.com/video/704389131?h=22b0f8a65b&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
            frameborder="0"
            allow="autoplay; fullscreen; picture-in-picture"
            allowfullscreen
            style="
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
            "
            title="Como Vincular Sua Conta XP na OnTick Invest"
          ></iframe>
        </div>
      </div>
      <p class="text-xs text-gray-500 dark:text-gray-400">
        Ainda ficou com dúvidas? Fale com nosso suporte!
      </p>
    </ontick-modal>
  </transition>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
export default {
  data() {
    return {
      data: {},
      term_of_use: false,
      options: {
        loop: true,
        grabCursor: true,
        slidesPerView: 1,
        centeredSlides: true,
        spaceBetween: 30,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
    };
  },
  components: { Swiper, SwiperSlide },
  props: {
    id: { type: Number, default: null },
    active: { type: Boolean, default: null },
  },
};
</script>

<style lang="scss" scoped></style>
